import React from 'react';
import './Testimonials.css';

const testimonialsData = [
  {
    id: 1,
    name: "Priya Sharma",
    university: "Delhi University",
    course: "Data Science, AI, and Machine Learning",
    image: "PS",
    rating: 5,
    text: "The project-based approach helped me land a job at a top tech company. The hands-on experience was invaluable and the mentors were extremely supportive."
  },
  {
    id: 2,
    name: "Rahul Verma",
    university: "Panjab University, Chandigarh",
    course: "Full Stack Web Development",
    image: "RV",
    rating: 5,
    text: "ExtraByte's MERN stack course transformed my career. I went from knowing basic HTML to building full-stack applications. The certificate helped me get recognized by recruiters."
  },
  {
    id: 3,
    name: "Sneha Patel",
    university: "Gujarat University",
    course: "Cyber Security and Ethical Hacking",
    image: "SP",
    rating: 5,
    text: "As a student from Gujarat University, I found the cybersecurity course to be comprehensive and practical. The projects were challenging and taught me real-world security practices."
  },
  {
    id: 4,
    name: "Arjun Kumar",
    university: "Lucknow University",
    course: "Python and Its Applications",
    image: "AK",
    rating: 5,
    text: "The Python course was perfect for beginners like me. The step-by-step approach and real projects made learning easy and fun. Highly recommended for all students!"
  },
  {
    id: 5,
    name: "Ananya Singh",
    university: "University of Rajasthan, Jaipur",
    course: "Digital Marketing",
    image: "AS",
    rating: 5,
    text: "ExtraByte's digital marketing course gave me practical skills that I could apply immediately. The affordable pricing made quality education accessible to me."
  },
  {
    id: 6,
    name: "Vikram Reddy",
    university: "Punjab Technical University, Jalandhar",
    course: "Data Science, AI, and Machine Learning",
    image: "VR",
    rating: 5,
    text: "Coming from a tier-2 city, I was looking for affordable quality education. ExtraByte delivered exactly that. The AI/ML course content is industry-standard."
  }
];

function Testimonials() {
  return (
    <div className="testimonials-section">
      <div className="testimonials-header">
        <h2>What Our Students Say</h2>
        <p>Hear from students across Indian universities who transformed their careers</p>
      </div>
      
      <div className="testimonials-grid">
        {testimonialsData.map((testimonial) => (
          <div key={testimonial.id} className="testimonial-card">
            <div className="testimonial-header">
              <div className="student-avatar">{testimonial.image}</div>
              <div className="student-info">
                <h3>{testimonial.name}</h3>
                <p className="university">{testimonial.university}</p>
                <p className="course-taken">{testimonial.course}</p>
              </div>
            </div>
            <div className="testimonial-rating">
              {[...Array(testimonial.rating)].map((_, i) => (
                <span key={i} className="star">★</span>
              ))}
            </div>
            <p className="testimonial-text">"{testimonial.text}"</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Testimonials;
